<template>
  <CButton class="btn-block btn-facebook" v-on="$listeners" :text="text">
    <i class="fa fa-facebook mr-2"></i>
  </CButton>
</template>

<script>
import CButton from "../partials/CButton";

export default {
  components: {
    CButton,
  },
  data() {
    return {
      text: this.$t("sign_in_dialog.button.facebook"),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/variables";

.btn-facebook {
  background: $color-facebook-blue;
  color: white;

  &:hover {
    background: darken($color-facebook-blue, 10%);
  }
}
</style>
